import Vue from 'vue';
import Router from 'vue-router';
import auth from '@/auth';

import EmptyLayout from '@/components/EmptyLayout';
import Login from '@/components/Login';
import ForgotPassword from '@/components/ForgotPassword';
import ResetPassword from '@/components/ResetPassword';
import ErrorPage from '@/components/404';

import Profile from '@/components/userManager/Profile';

import CurrentEvent from '@/components/messages/CurrentEvent';
import SectionMessages from '@/components/messages/SectionMessages';
import MessageConfig from '@/components/messages/MessageConfig';

import TvManager from '@/components/tvManager/Index';
import Tv from '@/components/tvManager/Tv';
import Tablet from '@/components/tvManager/Tablet';
import Remote from '@/components/tvManager/Remote';
import Group from '@/components/tvManager/Group';
import Section from '@/components/tvManager/Section';

import SuitesManager from '@/components/suitesManager/Index';
import SuitesList from '@/components/suitesManager/List';
import SuitesGroups from '@/components/suitesManager/Groups';
import SuitesGroupsManager from '@/components/suitesManager/GroupsManager';


import EventManager from '@/components/eventManager/Index';
import Events from '@/components/eventManager/Events';
import Users from '@/components/eventManager/Users';
import Logs from '@/components/eventManager/Logs';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/reset/:hash',
      name: 'resetPassword',
      component: ResetPassword,
    },
    {
      path: '/',
      component: EmptyLayout,
      children: [
        {
          path: '/',
          component: CurrentEvent,
          name: 'currentEvent',
          beforeEnter: (to, from, next) => {
            if (auth.isLoggedIn()) {
              next();
            } else {
              next({ name: 'logIn' });
            }
          },
        },
        {
          path: 'tv-manager',
          component: TvManager,
          name: 'tvManager',
          beforeEnter: (to, from, next) => {
            if (auth.isLoggedIn() && auth.isAllowed(2)) {
              next();
            } else {
              next({ path: '/' });
            }
          },
          redirect: { name: 'tv' },
          children: [
            {
              path: 'tvs',
              component: Tv,
              name: 'tv',
            },
            {
              path: 'tablets',
              component: Tablet,
              name: 'tablet',
            },
            {
              path: 'remotes',
              component: Remote,
              name: 'remote',
            },
            {
              path: 'groups',
              component: Group,
              name: 'group',
            },
            {
              path: 'sections',
              component: Section,
              name: 'section',
            },
          ],
        },
        {
          path: 'suites-manager',
          component: SuitesManager,
          name: 'suitesManager',
          beforeEnter: (to, from, next) => {
            if (auth.isLoggedIn() && auth.isAllowed(2)) {
              next();
            } else {
              next({ path: '/' });
            }
          },
          redirect: { name: 'suitesList' },
          children: [
            {
              path: 'suites',
              component: SuitesList,
              name: 'suitesList',
            },
            {
              path: 'groups',
              component: SuitesGroups,
              name: 'suitesGroups',
            },
            {
              path: 'groups-manager',
              component: SuitesGroupsManager,
              name: 'suitesGroupsManager',
            },
          ],
        },
        {
          path: 'section-messages',
          component: EmptyLayout,
          beforeEnter: (to, from, next) => {
            if (auth.isLoggedIn()) {
              next();
            } else {
              next({ name: 'logIn' });
            }
          },
          children: [
            {
              path: '/',
              component: SectionMessages,
              name: 'sectionMessagesAll',
            },
            {
              path: 'config',
              component: EmptyLayout,
              children: [
                {
                  path: '/',
                  redirect: {
                    name: 'messageConfigNew',
                  },
                },
                {
                  path: 'new',
                  component: MessageConfig,
                  name: 'messageConfigNew',
                },
                {
                  path: ':id',
                  component: MessageConfig,
                  name: 'messageConfig',
                },
              ],
            },
            {
              path: ':id',
              component: SectionMessages,
              name: 'sectionMessages',
            },
          ],
        },
        {
          path: 'event-manager',
          name: 'eventManager',
          component: EventManager,
          redirect: { name: 'logs' },
          beforeEnter: (to, from, next) => {
            if (auth.isLoggedIn()) {
              next();
            } else {
              next({ name: 'logIn' });
            }
          },
          children: [
            {
              path: 'events',
              component: Events,
              name: 'events',
              beforeEnter: (to, from, next) => {
                if (auth.isAllowed(1)) {
                  next();
                } else {
                  next({ path: '/' });
                }
              },
            },
            {
              path: 'logs',
              component: Logs,
              name: 'logs',
            },
          ],
        },
        {
          path: 'login',
          component: Login,
          name: 'logIn',
        },
        {
          path: '/forgot-password',
          name: 'forgotPassword',
          component: ForgotPassword,
        },
        {
          path: 'user-manager',
          name: 'userManager',
          component: EventManager,
          redirect: { name: 'profile' },
          beforeEnter: (to, from, next) => {
            if (auth.isLoggedIn()) {
              next();
            } else {
              next({ name: 'logIn' });
            }
          },
          children: [
            {
              path: 'users',
              component: Users,
              name: 'users',
              beforeEnter: (to, from, next) => {
                if (auth.isAllowed(2)) {
                  next();
                } else {
                  next({ name: 'profile' });
                }
              },
            },
            {
              path: 'profile',
              component: Profile,
              name: 'profile',
            },
          ],
        },
        {
          path: '/*',
          name: '404',
          component: ErrorPage,
        },
      ],
    },
  ],
  mode: 'history',
});

router.beforeEach((to, from, next) => {
  const role = auth.role();
  if (role === '3' && !['suitesManager', 'suitesList', 'suitesGroups', 'suitesGroupsManager'].includes(to.name)) {
    next({ name: 'suitesList' });
    return;
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js